import { render, staticRenderFns } from "./omanagement.vue?vue&type=template&id=425665c6&scoped=true"
import script from "./omanagement.vue?vue&type=script&lang=js"
export * from "./omanagement.vue?vue&type=script&lang=js"
import style1 from "./omanagement.vue?vue&type=style&index=1&id=425665c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425665c6",
  null
  
)

export default component.exports